import { GroupSortingField } from '@/gql/enums';

export enum GroupColumnKey {
    Id = 'id',
    Name = 'name',
    Description = 'description',
    UpdatedAt = 'updatedAt',
    TotalMemberCount = 'totalMemberCount',
}

/**
 * Maps UI column keys to the backend sorting field names
 */
export const getSortField = (columnKey: GroupColumnKey): GroupSortingField | null => {
    switch (columnKey) {
        case GroupColumnKey.Name:
            return GroupSortingField.Name;
        case GroupColumnKey.Description:
            return GroupSortingField.Description;
        case GroupColumnKey.UpdatedAt:
            return GroupSortingField.UpdatedAt;
        case GroupColumnKey.TotalMemberCount:
            return GroupSortingField.MemberCount;
        default:
            return null;
    }
};
